import { FormlyFieldConfig } from "@ngx-formly/core"
import * as _ from "lodash"
import { EMAIL_FIELD } from "./generic.fields"

const CN_OCCUPATIONS = [
	{
		label: "Businessperson",
		value: "Businessperson"
	},
	{
		label: "Company employee",
		value: "Company employee"
	},
	{
		label: "Entertainer",
		value: "Entertainer"
	},
	{
		label: "Industrial/agricultural worker",
		value: "Industrial/agricultural worker"
	},
	{
		label: "Student",
		value: "Student"
	},
	{
		label: "Member of parliament",
		value: "Member of parliament"
	},
	{
		label: "Government official",
		value: "Government official"
	},
	{
		label: "Military personnel",
		value: "Military personnel"
	},
	{
		label: "NGO staff",
		value: "NGO staff"
	},
	{
		label: "Religious personnel",
		value: "Religious personnel"
	},
	{
		label: "Media representative",
		value: "Media representative"
	},
	{
		label: "Crew member",
		value: "Crew member"
	},
	{
		label: "Self-employed",
		value: "Self-employed"
	},
	{
		label: "Unemployed",
		value: "Unemployed"
	},
	{
		label: "Retired",
		value: "Retired"
	},
	{
		label: "Academic",
		value: "Academic"
	},
	{
		label: "Other",
		value: "Other"
	}
]

const CN_PREVIOUS_VISA_TYPES = [
	{
		label: "A",
		value: "A"
	},
	{
		label: "GA",
		value: "GA"
	},
	{
		label: "B",
		value: "B"
	},
	{
		label: "GB",
		value: "GB"
	},
	{
		label: "Y",
		value: "Y"
	},
	{
		label: "L",
		value: "L"
	},
	{
		label: "C",
		value: "C"
	},
	{
		label: "D",
		value: "D"
	},
	{
		label: "F",
		value: "F"
	},
	{
		label: "G",
		value: "G"
	},
	{
		label: "J1",
		value: "J1"
	},
	{
		label: "J2",
		value: "J2"
	},
	{
		label: "Q1",
		value: "Q1"
	},
	{
		label: "Q2",
		value: "Q2"
	},
	{
		label: "RC",
		value: "RC"
	},
	{
		label: "S1",
		value: "S1"
	},
	{
		label: "S2",
		value: "S2"
	},
	{
		label: "X1",
		value: "X1"
	},
	{
		label: "X2",
		value: "X2"
	},
	{
		label: "Z",
		value: "Z"
	},
	{
		label: "M",
		value: "M"
	},
	{
		label: "S",
		value: "S"
	},
	{
		label: "O",
		value: "O"
	},
	{
		label: "GU",
		value: "GU"
	},
	{
		label: "MQ",
		value: "MQ"
	},
	{
		label: "U",
		value: "U"
	},
	{
		label: "W",
		value: "W"
	},
	{
		label: "L-团",
		value: "L-团"
	},
	{
		label: "Other",
		value: "Other"
	},
	{
		label: "K",
		value: "K"
	}
]

const CN_PERSON_LIST_FIELD_ARRAY = {
	fieldGroup: [
		{
			fieldGroup: [
				{
					key: "first_name",
					type: "name-field",
					props: {
						label: "First Name",
						required: true
					},
					className: "gwc-form__field gwc-form__field--grow"
				},
				{
					key: "last_name",
					type: "name-field",
					props: {
						label: "Last Name",
						required: true
					},
					className: "gwc-form__field gwc-form__field--grow"
				}
			],
			fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
		},
		{
			fieldGroup: [
				{
					key: "nationality",
					type: "country-autocomplete",
					props: {
						label: "Nationality",
						required: true
					},
					className: "gwc-form__field gwc-form__field--grow"
				},
				{
					key: "date_of_birth",
					type: "datepicker",
					props: {
						view: "multi-year",
						label: "Date of Birth",
						required: true,
						before: [
							{
								date: "now",
								message: "Date can't be in the future."
							}
						]
					},
					className: "gwc-form__field gwc-form__field--grow"
				}
			],
			fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
		}
	]
}

export const CN_FIELDS = {
	name: {
		type: "input",
		props: {
			label: "Chinese Name",
			maxLength: 30
		}
	},
	occupation: {
		type: "select",
		props: {
			label: "Current Occupation",
			options: CN_OCCUPATIONS
		}
	},
	spouse: {
		occupation: {
			type: "select",
			props: {
				label: "Occupation",
				options: CN_OCCUPATIONS
			}
		}
	},
	father: {
		in_china: {
			type: "yes-no-buttons"
		}
	},
	mother: {
		in_china: {
			type: "yes-no-buttons"
		}
	},
	relatives_in_china: {
		answer: {
			type: "yes-no-buttons"
		},
		list: {
			type: "multiple",
			fieldArray: CN_PERSON_LIST_FIELD_ARRAY,
			defaultValue: [
				null
			]
		}
	},
	questions: {
		refused_visa: {
			answer: {
				type: "yes-no-buttons"
			}
		},
		visa_canceled: {
			answer: {
				type: "yes-no-buttons"
			}
		},
		illegal_entry: {
			answer: {
				type: "yes-no-buttons"
			}
		}
	},
	visited_before: {
		answer: {
			type: "yes-no-buttons"
		}
	},
	previous_visa: {
		answer: {
			type: "yes-no-buttons",
			hooks: {
				onInit: (field: FormlyFieldConfig) => {
					if (field.formControl?.value) return

					let root: FormlyFieldConfig | undefined = field.parent
					while (root && root.parent) root = root.parent

					const visited = _.get(root?.model || field.model, "cn.visited_before.answer")
					if (visited === "yes") field.formControl?.setValue("yes")
				}
			}
		},
		photo_available: {
			answer: {
				type: "yes-no-buttons"
			}
		},
		type: {
			type: "select",
			props: {
				label: "Type of Visa",
				options: CN_PREVIOUS_VISA_TYPES
			}
		},
		number: {
			type: "input",
			props: {
				label: "Visa Number",
				pattern: "^[A-Za-z0-9]+$",
				maxLength: 20
			}
		},
		place_of_issue: {
			type: "input",
			props: {
				label: "Place of Issue",
				maxLength: 50
			}
		},
		issue_date: {
			type: "datepicker",
			props: {
				view: "multi-year",
				label: "Date of Issue",
				before: [
					{
						date: "now",
						message: "Date can't be in the future."
					}
				]
			}
		},
		fingerprints: {
			answer: {
				type: "yes-no-buttons"
			}
		},
		residence_permit: {
			answer: {
				type: "yes-no-buttons"
			}
		},
		name_changed: {
			answer: {
				type: "yes-no-buttons"
			}
		},
		scan: {
			props: {
				type: "pdf_document",
				message: "Please take a picture or upload a copy of your most recent Chinese visa.",
				model_type: "profile",
				friendly_name: "Most Recent Chinese Visa"
			}
		},
		lost_statement: {
			props: {
				type: "pdf_document",
				message: "Please upload a lost visa statement.",
				client_view: `
					<ul>
						<li>A lost visa statement is a signed, written explanation of when and how the previous Chinese visa was lost.</li>
						<li>It should include the approximate date the visa was issued and the circumstances in which it was lost.</li>
					</ul>
				`,
				model_type: "profile",
				friendly_name: "Lost Visa Statement"
			}
		},
		name_change_proof: {
			props: {
				type: "pdf_document",
				message: "Please take a picture or upload proof of your name change to your current name.",
				model_type: "profile",
				friendly_name: "Proof of Name Change"
			}
		}
	}
}

export const CN_APPLICATION_FIELDS = {
	tourist_type: {
		type: "buttons",
		props: {
			label: "Tourist Type",
			options: [
				{
					label: "Individual",
					value: "individual"
				},
				{
					label: "Group",
					value: "group"
				}
			]
		}
	},
	entry: {
		transport_number: {
			type: "input",
			props: {
				label: "Train/Ship/Flight Number",
				maxLength: 20
			}
		},
		destination_city: {
			type: "cn-city",
			props: {
				label: "Destination City"
			}
		},
		destination_district: {
			type: "cn-district",
			props: {
				label: "Destination District/County",
				parentKey: "destination_city"
			}
		},
		destination_district_manual: {
			type: "cn-district-manual",
			props: {
				label: "Destination District/County",
				parentKey: "destination_city"
			}
		}
	},
	exit: {
		transport_number: {
			type: "input",
			props: {
				label: "Train/Ship/Flight Number",
				maxLength: 20
			}
		},
		departure_city: {
			type: "cn-city",
			props: {
				label: "City of Departure"
			}
		},
		departure_district: {
			type: "cn-district",
			props: {
				label: "District/County of Departure",
				parentKey: "departure_city"
			}
		},
		departure_district_manual: {
			type: "cn-district-manual",
			props: {
				label: "District/County of Departure",
				parentKey: "departure_city"
			}
		}
	},
	accommodations: {
		list: {
			type: "multiple",
			fieldArray: {
				fieldGroup: [
					{
						fieldGroup: [
							{
								key: "city",
								type: "cn-city",
								props: {
									label: "City",
									required: true
								},
								className: "gwc-form__field gwc-form__field--grow"
							},
							{
								key: "district",
								type: "cn-district",
								props: {
									label: "District/County"
								},
								className: "gwc-form__field gwc-form__field--grow"
							},
							{
								key: "district_manual",
								type: "cn-district-manual",
								props: {
									label: "District/County"
								},
								className: "gwc-form__field gwc-form__field--grow"
							}
						],
						fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
					},
					{
						key: "address",
						type: "input",
						props: {
							label: "Address",
							maxLength: 150,
							required: true
						},
						className: "gwc-form__field gwc-form__field--grow"
					},
					{
						fieldGroup: [
							{
								key: "from",
								type: "datepicker",
								props: {
									view: "multi-year",
									label: "From",
									required: true,
									after: [
										{
											key: "application.date_of_entry",
											parent: "global",
											message: "Date can't be before Date of Entry."
										}
									]
								},
								className: "gwc-form__field gwc-form__field--grow"
							},
							{
								key: "to",
								type: "datepicker",
								props: {
									view: "multi-year",
									label: "To",
									required: true,
									after: [
										{
											key: "application.date_of_entry",
											parent: "global",
											message: "Date can't be before Date of Entry."
										}
									]
								},
								className: "gwc-form__field gwc-form__field--grow"
							}
						],
						fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
					}
				]
			},
			defaultValue: [
				null
			]
		}
	},
	host: {
		name: {
			type: "input",
			props: {
				label: "Name of the Person/Organization",
				maxLength: 100
			}
		},
		relationship: {
			type: "input",
			props: {
				label: "Relationship to You",
				maxLength: 50
			}
		},
		phone: {
			type: "input",
			props: {
				label: "Phone Number",
				maxLength: 20
			}
		},
		email: EMAIL_FIELD,
		province: {
			type: "cn-province"
		},
		city: {
			type: "cn-city-by-province"
		},
		district: {
			type: "cn-district"
		},
		district_manual: {
			type: "cn-district-manual"
		},
		post_code: {
			type: "input",
			props: {
				label: "Post Code",
				maxLength: 10
			}
		}
	},
	payer: {
		type: {
			type: "select",
			props: {
				label: "Who Will Be Paying for This Travel",
				options: [
					{
						label: "Myself",
						value: "self"
					},
					{
						label: "Another Person",
						value: "other"
					},
					{
						label: "An Organization",
						value: "organization"
					}
				]
			}
		},
		name: {
			type: "input",
			props: {
				label: "Name",
				maxLength: 100
			}
		},
		phone: {
			type: "input",
			props: {
				label: "Telephone",
				maxLength: 20
			}
		},
		email: EMAIL_FIELD,
		relationship: {
			type: "input",
			props: {
				label: "Relationship to You",
				maxLength: 50
			}
		},
		address: {
			type: "input",
			props: {
				label: "Address",
				maxLength: 150
			}
		},
		country: {
			type: "country-autocomplete",
			props: {
				label: "Country"
			}
		}
	},
	shared_passport_traveler: {
		answer: {
			type: "yes-no-buttons",
			defaultValue: "no"
		}
	},
	questions: {
		epidemic_regions: {
			answer: {
				type: "yes-no-buttons"
			}
		},
		other_declaration: {
			answer: {
				type: "yes-no-buttons"
			}
		}
	}
}
